// extracted by mini-css-extract-plugin
module.exports = {"mCurated":"yg","flipped":"zg","mainContentContainer":"Ag","cta":"Bg","mainContentCtaDefault":"Cg","disabled":"Dg","mainContentCtaWhite":"Eg"};